module.exports = __webpack_public_path__ + "img/004.91d012b6.jpg";